'use client';

import type { Service } from '@ahm/api-wrappers-core';
import type { WebInAppConfig } from '@ahm/react-auth';
import type { JSX } from 'react';
import SurgeDownIcon from '@/assets/icons/surge-down-icon.svg';
import SurgeUpIcon from '@/assets/icons/surge-up-icon.svg';

export const surgeIcon = (
  service: any,
  surgePriceConfig: any[] | undefined
): JSX.Element | null => {
  if (
    !surgePriceConfig ||
    service.estimate_data?.error ||
    !service.estimate_data?.data?.surge_rate
  )
    return null;

  for (const item of surgePriceConfig) {
    if (item.delivery_type === service.delivery_type) {
      const currentSurgeRate = service.estimate_data?.data?.surge_rate;

      if (
        item.surge_rate_decrease &&
        currentSurgeRate < item.surge_rate_decrease
      ) {
        return <SurgeDownIcon />;
      } else if (
        item.surge_rate_increase &&
        currentSurgeRate > item.surge_rate_increase
      ) {
        return <SurgeUpIcon />;
      }
    }
  }
  return null;
};

export const getMaxCod = (
  service: Service,
  user: any,
  webInAppConfig?: WebInAppConfig
): { max_cod: number; max_cod_per_stop_point: number } => {
  if (user?.verified && user.max_cod) {
    return {
      max_cod: service.max_cod,
      max_cod_per_stop_point: user.max_cod,
    };
  }

  const configMaxCod = webInAppConfig?.maxCod ?? service.max_cod;
  return {
    max_cod: configMaxCod,
    max_cod_per_stop_point: configMaxCod,
  };
};

export const showAlertNoService = (
  setAlertBooking: (alert: { title: string; description: string }) => void,
  pathsLength: number
) => {
  setAlertBooking({
    title: 'Không thể tải danh sách dịch vụ',
    description: pathsLength
      ? 'Xin lỗi, dịch vụ này chưa hỗ trợ lấy hàng tại khu vực trên. Vui lòng sử dụng dịch vụ khác hoặc chọn địa chỉ lấy hàng khác'
      : 'Vui lòng nhập địa chỉ lấy hàng để xem danh sách dịch vụ.',
  });
};
